import { useEffect } from 'react';

const STYLE_ID = 'receipt-fullscreen-styles';

const FULLSCREEN_STYLES = `
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  body > div:has(.modal-wrapper) .modal-wrapper,
  .modal-wrapper {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    animation: fadeIn 0.3s ease-out !important;
  }
  body > div:has(.modal-content) .modal-content,
  .modal-content {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  .two-column-modal-content {
    width: 100vw !important;
    flex: 1 !important;
    min-height: 0 !important;
  }
`;

export const useFullscreenModalStyles = (isFullscreen: boolean): void => {
  useEffect(() => {
    if (isFullscreen) {
      let styleElement = document.getElementById(STYLE_ID);

      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = STYLE_ID;
        document.head.appendChild(styleElement);
      }

      styleElement.textContent = FULLSCREEN_STYLES;
    } else {
      const element = document.getElementById(STYLE_ID);
      if (element) {
        element.remove();
      }
    }

    return () => {
      const element = document.getElementById(STYLE_ID);
      if (element) {
        element.remove();
      }
    };
  }, [isFullscreen]);
};
